import React, { useEffect, useState } from 'react';
import { useReportContext } from '../../../_context/ReportContext';
import { ClientType } from '../../../_models/Client.model';
import { useCreateReportNotificationContext } from '../../../_context/CreateReportNotificationContext';
import { ClientGotConsent } from './ClientConsent/ClientGotConsent';
import { ClientNoConsent } from './ClientConsent/ClientNoConsent';
import { useClientContext } from '../../../_context/ClientContext';
import { useNavigate } from 'react-router-dom';
import "../../Admin/AddUsers/AddUsers.css";
import "../Reports.css";

const ShieldCheckIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="M9 12l2 2 4-4" />
  </svg>
);

const ShieldAlertIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

export const ClientConsent = () => {
  const navigate = useNavigate();
  const { newReport } = useReportContext();
  const [consentGiven, setConsentGiven] = useState<boolean | null>(null);
  const { clientForReporting } = useClientContext();
  const { setDisplayNotification, setNotification } = useCreateReportNotificationContext();

  useEffect(() => {
    if (!clientForReporting.Name) {
      setDisplayNotification(true);
      setNotification("Please select a Client to create reports");
      navigate("/reports/select_client_for_new_report");
    }
  }, [clientForReporting.Name, navigate, setDisplayNotification, setNotification]);

  return (
    <div className="reports-page-wrapper" style={{ maxWidth: 800 }}>
      {/* Header */}
      <div className="rp-client-header" style={{ background: "linear-gradient(135deg, #4c1d95 0%, #6d43b9 100%)" }}>
        <h2 className="rp-client-title">Step 2: Client Consent</h2>
        <div className="rp-client-email">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
          </svg>
          Client: <strong>{newReport.Client?.Name} {newReport.Client?.Type === ClientType.AirBNB && newReport.ClientName ? `(${newReport.ClientName})` : ''}</strong>
        </div>
      </div>

      {/* Consent Document */}
      <div className="au-card" style={{ marginBottom: 24 }}>
        <div className="au-card-header">
          <div className="au-card-header-icon" style={{ background: "rgba(109,67,185,0.1)", color: "#6d43b9" }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" />
            </svg>
          </div>
          <div>
            <p className="au-card-header-title">Acknowledgement of Inspection</p>
            <p className="au-card-header-sub">Please review the following consent paragraph</p>
          </div>
        </div>

        <div className="au-card-body" style={{ background: "#F9FAFB", padding: "30px", borderBottom: "1px solid #E5E7EB" }}>
          <p style={{ fontSize: "0.95rem", lineHeight: 1.7, color: "#374151" }}>
            We, <strong>{newReport.Client?.Name} {newReport.Client?.Type === ClientType.AirBNB && newReport.ClientName ? `(${newReport.ClientName})` : ''}</strong>, acknowledge that CNA
            Cleaning Services will be conducting cleaning inspections at our
            facility. We understand that this is necessary to maintain a clean
            and safe environment for employees and customers. I consent to CNA
            Cleaning Services entering the premises for the purpose of
            conducting these inspections.
          </p>
          <p style={{ fontSize: "0.95rem", lineHeight: 1.7, color: "#374151", marginBottom: 0 }}>
            Thank you for your cooperation in helping us maintain a safe and
            clean environment. If you have any questions or concerns, please do
            not hesitate to contact us. <br /><br />
            Sincerely, <br />
            <strong>CNA Cleaning Services</strong>
          </p>
        </div>

        <div className="au-card-body" style={{ padding: "24px" }}>
          <p style={{ textAlign: "center", fontWeight: 600, color: "#0f1c34", marginBottom: 20 }}>
            Has the client provided consent for this inspection?
          </p>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
            <button
              className="admin-action-card"
              style={{ textAlign: "left", width: "100%", border: consentGiven === true ? "2px solid #16a34a" : "1px solid #E5E7EB", background: consentGiven === true ? "rgba(22,163,74,0.02)" : "#fff" }}
              onClick={() => setConsentGiven(true)}
            >
              <div>
                <div className="admin-card-icon-wrap success" style={{ background: "rgba(22,163,74,0.1)", color: "#16a34a", marginBottom: 12 }}>
                  <ShieldCheckIcon />
                </div>
                <p className="admin-card-label" style={{ fontSize: "1rem" }}>Consent Granted</p>
                <p className="admin-card-desc">Client approved access</p>
              </div>
            </button>

            <button
              className="admin-action-card"
              style={{ textAlign: "left", width: "100%", border: consentGiven === false ? "2px solid #dc2626" : "1px solid #E5E7EB", background: consentGiven === false ? "rgba(220,38,38,0.02)" : "#fff" }}
              onClick={() => setConsentGiven(false)}
            >
              <div>
                <div className="admin-card-icon-wrap danger" style={{ background: "rgba(220,38,38,0.1)", color: "#dc2626", marginBottom: 12 }}>
                  <ShieldAlertIcon />
                </div>
                <p className="admin-card-label" style={{ fontSize: "1rem" }}>Consent Denied</p>
                <p className="admin-card-desc">Access to property refused</p>
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Render sub-component based on selection */}
      {consentGiven === true && <ClientGotConsent />}
      {consentGiven === false && <ClientNoConsent />}
    </div>
  );
};
